import { render } from "./InventoryTable.vue?vue&type=template&id=35fbe0d5&scoped=true"
import script from "./InventoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryTable.vue?vue&type=script&lang=js"

import "./InventoryTable.vue?vue&type=style&index=0&id=35fbe0d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fbe0d5"]])

export default __exports__